import { useQuery } from '@tanstack/react-query'
import { z } from 'zod'

import { httpService } from '@/api/v1/http.service'
import { requiredString } from '@/utils/zod'

import type { IdAndName } from '../types/id-and-name'

const responseSchema = z.object({
  id: requiredString(),
  display_name: requiredString()
})

type Course = IdAndName

const parseResponse = (response: z.infer<typeof responseSchema>): Course => ({
  id: response.id,
  name: response.display_name
})

export const courseQueryOptions = (courseId: string) => ({
  queryKey: ['panelCoursesRetrieve', courseId],
  staleTime: 60 * 100,
  queryFn: async () => {
    const courseResponse = await httpService.panel.panelCoursesRetrieve(
      courseId,
      {
        fetchKeys: {
          id: true,
          display_name: true
        }
      }
    )
    return parseResponse(responseSchema.parse(courseResponse))
  }
})

const useCourse = (courseId: string) => useQuery(courseQueryOptions(courseId))

export default useCourse
